import { Grid, Skeleton, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
/**
 * @param {string} title - Title is string parameter.
 * @param {string|Array[string]} description - Description can be a string for one paragraph. To get multiple paragraph use Array of strings.
 * @param {object} style - style title, description
 * @param {string} textAlign - To align both title and description(s). By default 'center'.  (left | right | center* | justify)
 */
const EirInformation = ({
  title = 'Title',
  description = '',
  textAlign = 'center',
  loading,
  style,
  subtitle = '',
  isMbb,
  titleVariant,
  descriptionVariant,
  useH1,
  makeH1,
}) => {
  const theme = useTheme();
  return (
    <Grid
      item
      container
      justifyContent='center'
      sx={{ width: '100%', m: 0, alignContent: 'center' }}
    >
      <Grid item xs={12} sm={12} sx={{ p: 0 }}>
        {loading ? (
          <Skeleton
            height={40}
            width={220}
            sx={textAlign ? { m: '0 auto 0rem', bgcolor: 'gray' } : {}}
          />
        ) : (
          <Typography
            // variant={titleVariant || 'h2'}
            variant={makeH1 || useH1 ? 'h1' : titleVariant || 'h1'}
            component={titleVariant === 'subtitle1' ? 'p' : undefined}
            textAlign={textAlign}
            sx={
              isMbb !== undefined && isMbb
                ? {
                    color: theme.palette.secondary.mobileActiveToggleBackground,
                    ...style?.title,
                  }
                : {
                    mt: '3rem',
                    color: theme.palette.secondary.mobileActiveToggleBackground,
                    ...style?.title,
                  }
            }
          >
            {title}
            {subtitle && (
              <span
                style={{
                  fontFamily: theme.typography.body1.fontFamily,
                  color: theme.palette.primary.textColor3,
                }}
              >
                {` ${subtitle}`}
              </span>
            )}
          </Typography>
        )}
      </Grid>
      <Grid item xs={12} sm={12} sx={{ p: 0 }}>
        {loading ? (
          <>
            <Skeleton height={16} width='80%' sx={textAlign ? { m: '0 auto' } : {}} />
            <Skeleton height={16} width='60%' sx={textAlign ? { m: '0 auto' } : {}} />
          </>
        ) : (
          <>
            {typeof description === 'string' && (
              <Typography
                variant={descriptionVariant}
                textAlign={textAlign}
                color={theme.palette.secondary.mobileActiveToggleBackground}
                sx={{ ...style?.description }}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
            {description === 'object' &&
              description.map(text => (
                <Typography
                  textAlign={textAlign}
                  color={theme.palette.secondary.mobileActiveToggleBackground}
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              ))}
          </>
        )}
      </Grid>
    </Grid>
  );
};
EirInformation.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  textAlign: PropTypes.oneOf(['center', 'left', 'right', 'justify']),
};
EirInformation.defaultProps = {
  textAlign: 'center',
  description: '',
};

export default EirInformation;
